<div class="flx-modal" role="dialog" aria-modal="true">
    <div class="flx-modal__header">
        <div class="with-desc">
            <h2>{{translate?.general.buttons.generate.singular}} {{translate?.jobOrder.label.singular}}</h2>
        </div>
        <button class="icon-btn" aria-label="Close" [pTooltip]="translate?.general.buttons.close.singular"
            (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>
    <div class="flx-modal__subheader">
      <h3>{{translate?.general.buttons.create.singular}} {{translate?.jobOrder.label.plural | lowercase}} {{translate?.planner.messages.fromTheSelectedPeriod}} {{translate?.planner.messages.narrowTheScope}} {{translate?.setup.users.users.label.singular | lowercase}}, {{translate?.setup.modules.preventiveFrequency.label.singular |lowercase}}, {{translate?.site.fields.building.singular | lowercase}}, {{translate?.site.label.singular}}, {{translate?.planner.messages.or}} {{translate?.site.fields.area.singular | lowercase}} {{translate?.planner.messages.leaveAnyFilterOnAll}}</h3>
    </div>
    <div class="flx-modal__body">
        <div class="status-field">
           <label class="field-label mandatory">{{translate?.planner.fields.duration.singular}}</label>
            <div class="mp-inline-row-box mp-row">
                <button type="button" class="mp-note-option" [class.is-selected]="duration === 'THIS_MONTH'"
                    (click)="selectDuration('THIS_MONTH')">{{translate?.planner.messages.thisMonth}}</button>
                <button type="button" class="mp-note-option" [class.is-selected]="duration === 'NEXT_MONTH'"
                    (click)="selectDuration('NEXT_MONTH')">{{translate?.planner.messages.nextMonth}}</button>
                <button type="button" class="mp-note-option" [class.is-selected]="duration === 'NEXT_3_MONTH'"
                    (click)="selectDuration('NEXT_3_MONTH')">{{translate?.planner.messages.next3Months}}</button>
                <button type="button" class="mp-note-option" [class.is-selected]="duration === 'customRange'"
                    (click)="selectDuration('customRange')">{{translate?.planner.messages.customRange}}</button>
            </div>
            <!-- Conditional: Custom range date pickers -->
            <div class="mp-row" *ngIf="duration === 'customRange'">
                <form [formGroup]="dateRangeForm" class="field-row--auto_range">
                    <div class="status-field">
                        <span class="field-label mandatory">{{translate?.planner.fields.startDate.singular}}</span>
                        <p-calendar formControlName="customRangeStart"
                            [maxDate]="maxStartDate" placeholder="dd/mm/yy"
                            dateFormat="d/m/yy" [showIcon]="true" appendTo="body" styleClass="cal-btn"></p-calendar>
                        <div class="p-error text-10" 
                            *ngIf="
                                (dateRangeForm.controls['customRangeStart'].touched || dateRangeForm.controls['customRangeStart'].dirty) &&
                                dateRangeForm.controls['customRangeStart'].invalid
                            ">
                            <span *ngIf="dateRangeForm.controls['customRangeStart'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                        </div>
                    </div>
                    <span class="divider"><i class="fa-solid fa-minus"></i></span>
                    <div class="status-field">
                        <span class="field-label mandatory">{{translate?.planner.fields.endDate.singular}}</span>
                        <p-calendar formControlName="customRangeEnd" dateFormat="d/m/yy" [minDate]="minEndDate" placeholder="dd/mm/yy"
                            [showIcon]="true" appendTo="body" styleClass="cal-btn"></p-calendar>
                        <div class="p-error text-10" 
                            *ngIf="
                                (dateRangeForm.controls['customRangeEnd'].touched || dateRangeForm.controls['customRangeEnd'].dirty) &&
                                dateRangeForm.controls['customRangeEnd'].invalid
                            ">
                            <span *ngIf="dateRangeForm.controls['customRangeEnd'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <form [formGroup]="jobPlannerForm" class="mt-2">
            <div class="status-field">
                <label class="field-label mandatory">{{translate?.setup.modules.types.fields.job.singular}} {{translate?.setup.modules.preventiveFrequency.label.singular}}</label>
                <div class="field-row field-row--auto">
                    <p-multiSelect formControlName="frequency" [placeholder]="translate?.general.messages.none" [options]="frequencyList" optionValue="value" optionLabel="name" display="chip"></p-multiSelect>
                </div>
                <div class="p-error text-10" 
                    *ngIf="
                        (jobPlannerForm.controls['frequency'].touched || jobPlannerForm.controls['frequency'].dirty) &&
                        jobPlannerForm.controls['frequency'].invalid
                    ">
                    <span *ngIf="jobPlannerForm.controls['frequency'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                </div>
            </div>

            <div class="status-field">
                <label class="field-label">{{translate?.site.label.singular}}</label>
                <div class="field-row field-row--auto">
                    <!-- <div class="p-inputgroup search">
                        <span class="p-input-icon-right w-100">
                            <p-autoComplete formControlName="site" appendTo="body" (onSelect)="onSiteSelect($event)" field="siteName"
                                [suggestions]="allSites" (completeMethod)="getSite($event)"
                                [placeholder]="translate?.general.messages.none"
                                [ngClass]="{'ng-invalid ng-dirty': jobPlannerForm.controls['site'].touched && jobPlannerForm.controls['site'].invalid}">
                            </p-autoComplete>
                            <i *ngIf="selectedSite" (click)="clearSite()" class="p-autocomplete-clear-icon pi pi-times "></i>
                        </span>
                        <button type="button" pButton icon="fa-regular fa-magnifying-glass" [pTooltip]="translate?.site.tooltips.siteLookup.singular" tooltipPosition="left" (click)="showSite = true"></button>
                    </div> -->
                    <p-multiSelect formControlName="site" [placeholder]="translate?.general.messages.none" (onChange)="loadMetaToGenerateJob('site', $event)" 
                        [options]="sites" optionValue="id" optionLabel="name" display="chip"></p-multiSelect>

                </div>
                <div class="p-error text-10" 
                    *ngIf="
                        (jobPlannerForm.controls['site'].touched || jobPlannerForm.controls['site'].dirty) &&
                        jobPlannerForm.controls['site'].invalid
                    ">
                    <span *ngIf="jobPlannerForm.controls['site'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                </div>
                <!-- <footer *ngIf="showSite" class="custella-form-container-footer hidePopup">
                    <p-dialog [header]="translate?.site.sections.sec2.singular" [(visible)]="showSite" showEffect="fade"
                        [style]="{ width: '70vw' }" [modal]="true" [draggable]="false">
                        <app-custella-sites (itemSelector)="onSiteSelect($event)" (closeView)="showSite = false"></app-custella-sites>
                    </p-dialog>
                </footer> -->
            </div>

            <div class="status-field">
                <label class="field-label mandatory">{{translate?.planner.fields.buildingBlock.singular}}</label>
                <div class="field-row field-row--auto">
                    <p-multiSelect formControlName="block" [placeholder]="translate?.general.messages.none" [options]="blockList" optionLabel="name" optionValue="id" display="chip"
                        (onChange)="loadMetaToGenerateJob('block', $event)">
                    </p-multiSelect>
                </div>
                <div class="p-error text-10" 
                    *ngIf="
                        (jobPlannerForm.controls['block'].touched || jobPlannerForm.controls['block'].dirty) &&
                        jobPlannerForm.controls['block'].invalid
                    ">
                    <span *ngIf="jobPlannerForm.controls['block'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                </div>
            </div>

            <div class="status-field">
                <label class="field-label mandatory">{{translate?.site.fields.level.singular}}</label>
                <div class="field-row field-row--auto">
                    <p-multiSelect formControlName="level" [placeholder]="translate?.general.messages.none" [options]="levelList" optionLabel="name" optionValue="id" display="chip" (onChange)="loadMetaToGenerateJob('level', $event)"></p-multiSelect>
                </div>
                <div class="p-error text-10" 
                    *ngIf="
                        (jobPlannerForm.controls['level'].touched || jobPlannerForm.controls['level'].dirty) &&
                        jobPlannerForm.controls['level'].invalid
                    ">
                    <span *ngIf="jobPlannerForm.controls['level'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                </div>
            </div>

            <div class="status-field">
                <label class="field-label mandatory">{{translate?.site.fields.area.singular}}</label>
                <div class="field-row field-row--auto">
                    <p-multiSelect formControlName="area" [placeholder]="translate?.general.messages.none" [options]="areaList" optionLabel="name" optionValue="id" display="chip"></p-multiSelect>
                </div>
                 <div class="p-error text-10" 
                    *ngIf="
                        (jobPlannerForm.controls['area'].touched || jobPlannerForm.controls['area'].dirty) &&
                        jobPlannerForm.controls['area'].invalid
                    ">
                    <span *ngIf="jobPlannerForm.controls['area'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                </div>
            </div>

            <div class="status-field">
                <label class="field-label">{{translate?.jobOrder.fields.user.singular}} <i class="fa-regular fa-circle-info" [pTooltip]="translate?.planner.tooltips.userFilterOptional.singular"></i></label>
                <div class="field-row field-row--auto">
                    <p-multiSelect formControlName="user" [placeholder]="translate?.general.messages.none" [options]="users" optionValue="id" optionLabel="fullName" [filter]="true" display="chip"></p-multiSelect>
                </div>
            </div>
        </form>
    </div>
    <div class="flx-modal__footer-between"  *ngIf="estimatedJobCount">
        <div class="apply">
            <p class="mb-0 text-12">Estimated <strong class="font-bold">{{estimatedJobCount}}</strong> {{translate?.setup.modules.types.fields.job.plural}} will be generated</p>
            <!-- <p class="mb-0 text-12" *ngIf="estimatedJobCount > queueThreshold">This will run in batches. You'll be notified by email and in-app once it's done.</p> -->
        </div>
        <div class="triggers">
            <button type="button" class="custella-btn-white" (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular }}</button>
            <p-button styleClass="h-32" type="button" [loading]="generateJOInProgress" [disabled]="generateJOInProgress" (onClick)="generateJO()" [label]="translate?.general.buttons.generate.singular + ' ' + translate?.jobOrder.label.singular"></p-button>
        </div>
    </div>
    <div class="flx-modal__footer" *ngIf="!estimatedJobCount">
        <button type="button" class="custella-btn-white" (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular }}</button>
        <p-button styleClass="h-32" type="button" [loading]="generateJOInProgress" [disabled]="generateJOInProgress" (onClick)="generateJO()" [label]="translate?.general.buttons.generate.singular + ' ' + translate?.jobOrder.label.singular"></p-button>
    </div>
</div>